var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleEscuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.333328C3.31999 0.333328 0.333328 3.31999 0.333328 7C0.333328 10.68 3.31999 13.6667 7 13.6667C10.68 13.6667 13.6667 10.68 13.6667 7C13.6667 3.31999 10.68 0.333328 7 0.333328ZM5.66666 10.3333L2.33333 7L3.27333 6.06L5.66666 8.44666L10.7267 3.38666L11.6667 4.33333L5.66666 10.3333Z",
    fill: "#1B5E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleEscuro);
export default __webpack_public_path__ + "static/media/check-circle-escuro.24114dcd6b1b2ebcc933be6a85237cf4.svg";
export { ForwardRef as ReactComponent };